export default "__VITE_ASSET__V06rzrRP__"